import axios from "axios";
import * as url from "../helpers/url_helper"
const {REACT_APP_BACK_URL} = process.env;

const getFile = (token) => {
    return axios
        .get(REACT_APP_BACK_URL + url.GET_FILE_VIEW + token, {
            headers: {
                'responseType': 'blob',
            }
        })
        .then((response) => {
            return {
                filename: getFilename(response),
                data: base64ToArrayBuffer(response.data)
            };
        });
};

const getFileLegacy = (recordId, token) => {
    return axios
        .get(REACT_APP_BACK_URL + url.GET_FILE + recordId, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'responseType': 'blob',
            }
        })
        .then((response) => {
            return {
                filename: getFilename(response),
                data: base64ToArrayBuffer(response.data)
            };
        });
};

function getFilename(response) {
    let headerLine = response.headers['content-disposition'];
    if(!headerLine) return "file.pdf";
    let startFileNameIndex = headerLine.indexOf('"') + 1;
    let endFileNameIndex = headerLine.lastIndexOf('"');
    return headerLine.substring(startFileNameIndex, endFileNameIndex);
}

function base64ToArrayBuffer(data) {
    const binaryString = window.atob(data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
};

export default {
    getFile,
    getFileLegacy
};
